import React, { useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useUI } from '../contexts/UIContext';
import BackgroundVideo from '../assets/videos/1background.mp4';
import LetterGlitch from '../components/LetterGlitch'; // Re-import LetterGlitch

const AuthLayout = ({ children, currentScreen }) => {
    const { isDarkMode } = useUI();
    const videoRef = useRef(null);

    // Ensure video playback settings
    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.playbackRate = 0.75;
        }
    }, [isDarkMode]);

    return (
        <div
            className="relative w-full h-full min-h-screen overflow-hidden flex flex-col justify-between bg-black transition-colors duration-700"
            data-testid="auth-layout"
        >

            {/* Background Video Layer - ALWAYS VISIBLE as base */}
            <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
                <div className="w-full h-full relative">
                    <video
                        ref={videoRef}
                        src={BackgroundVideo}
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="w-full h-full object-cover scale-110"
                        style={{ objectFit: 'cover' }}
                    />

                    {/* Matrix Code Overlay - ONLY IN DARK MODE */}
                    {isDarkMode && (
                        <div className="absolute inset-0 z-1 opacity-50">
                            <LetterGlitch
                                glitchColors={['#2b45b2', '#55eeee', '#335ccc']}
                                glitchSpeed={50}
                                centerVignette={true}
                                outerVignette={false}
                                smooth={true}
                            />
                        </div>
                    )}

                    {/* Dynamic Overlay based on Theme */}
                    {isDarkMode ? (
                        // Dark Mode Overlay: Dark tint to blend video and matrix
                        <div className="absolute inset-0 bg-blue-950/60 mix-blend-multiply z-2" />
                    ) : (
                        // Light Mode Overlay: White/Light Blue tint
                        <div className="absolute inset-0 bg-white/70 mix-blend-lighten z-2" />
                    )}

                    {/* Additional Gradient for Text Readability (Bottom Up) */}
                    <div className={`absolute inset-0 z-3 bg-gradient-to-t ${isDarkMode ? 'from-black/90 via-black/40 to-transparent' : 'from-white/90 via-white/40 to-white/10'}`} />
                </div>
            </div>

            {/* Content Container */}
            <div className="relative z-10 w-full h-full flex flex-col pointer-events-auto flex-1">
                {children}
            </div>
        </div>
    );
};

export default AuthLayout;
